var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "30px",
    viewBox: "0 0 27.0 30.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1440,0 L1440,4174 L0,4174 L0,0 L1440,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5833333,0 C15.75,0 16.6666667,0.916666667 16.6666667,2.08333333 L16.6666667,11.6666667 L15,11.6666667 L15,2.5 C15,2 14.6666667,1.66666667 14.1666667,1.66666667 L2.5,1.66666667 C2,1.66666667 1.66666667,2 1.66666667,2.5 L1.66666667,25 L15,25 L15,16.6666667 L16.6666667,16.6666667 L16.6666667,27.9166667 C16.6666667,29.0833333 15.75,30 14.5833333,30 L2.08333333,30 C0.916666667,30 0,29.0833333 0,27.9166667 L0,2.08333333 C0,0.916666667 0.916666667,0 2.08333333,0 L14.5833333,0 Z M9.16666667,26.6666667 L7.5,26.6666667 C7.08333333,26.6666667 6.66666667,27 6.66666667,27.5 C6.66666667,27.9166667 7.08333333,28.3333333 7.5,28.3333333 L9.16666667,28.3333333 C9.58333333,28.3333333 10,27.9166667 10,27.5 C10,27.0833333 9.58333333,26.6666667 9.16666667,26.6666667 Z M21.6666667,8.33333333 L21.6666667,13.3333333 L26.6666667,13.3333333 L26.6666667,15 L21.6666667,15 L21.6666667,20 L20,20 L20,15 L15,15 L15,13.3333333 L20,13.3333333 L20,8.33333333 L21.6666667,8.33333333 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-144.0 -2204.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(100.0 2083.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.0 120.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.999999999999872 1.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 26.6666667,0 26.6666667,30 0,30 0,0",
    stroke: "none",
    fill: "#00095B"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileControl);
export default __webpack_public_path__ + "static/media/MobileControl.0e3201274ba20cc08bbd9af0bb1ccdb1.svg";
export { ForwardRef as ReactComponent };